export default "__VITE_ASSET__BZpl3MnB__"